function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "AAF5EBC4-30C0-4863-B213-8BD211710B57");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "v2---saved-searches-menu",
  transform: "translate(-967.000000, -85.000000)",
  fill: "#009435"
}, /*#__PURE__*/React.createElement("g", {
  id: "user-menu",
  transform: "translate(955.000000, 59.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu-saved-searches"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/star/on",
  transform: "translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6,20.6923077 L6,6.47115385 C6,5.65864784 6.65864784,5 7.47115385,5 L16.2980769,5 C17.1105829,5 17.7692308,5.65864784 17.7692308,6.47115385 L17.7692308,20.6923077 L11.8846154,17.2596154 L6,20.6923077 Z",
  id: "Path"
})))))))));

var SvgStarActive = function SvgStarActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star_active.f52ee824.svg";
export { ForwardRef as ReactComponent };